var waitFor = require('../utils/waitFor');

waitFor('body.page-template-contact', function() {

	function showForm(id){
    $('.contact-form-wrap').removeClass('is-active');
    $('#' + id).addClass('is-active');

    // hide buttons
    $('#contact-form-select').addClass('is-hidden');
    $('.contact-intro').hide();
	}

  function showSelection(){
    $('.contact-form-wrap').removeClass('is-active');
    $('#contact-form-select').removeClass('is-hidden');
    $('.contact-intro').show();
  }

  $('#contact-form-select').on('click', 'a', function(e){
  	var $button = $(e.currentTarget),
  		formId = $button.attr('href').substr(1);

    e.preventDefault();

    showForm(formId);

  });

  $('.back-to-select').on('click', function(e){
    e.preventDefault();

    showSelection();
  });

  $('.gform_confirmation_wrapper, .gform_validation_error').each(function(i, el){
    var formId = $(this).parent().attr('id');

    showForm(formId);
  });

  // if hashtag is set, show that form
  if(document.location.hash.length > 1)
    showForm(document.location.hash.substr(1));

});
